// Constrói o grupo top-level "CRM" da sidebar com a IA reorganizada
// (Início/Pipeline/Empresas diretos + Captura/Resultados subgrupos + Configurar no rodapé).
// Pura: recebe `t` (i18n), `accountScopedRoute` (monta o `to` com o accountId corrente)
export function buildCrmMenu({ t, accountScopedRoute }) {
  return {
    name: 'CRM',
    label: t('SIDEBAR.CRM'),
    icon: 'i-lucide-handshake',
    children: [
      {
        name: 'CrmHome',
        label: t('SIDEBAR.CRM_HOME'),
        icon: 'i-lucide-house',
        to: accountScopedRoute('crm_home'),
        activeOn: ['crm_home'],
      },
      {
        name: 'Pipeline',
        label: t('SIDEBAR.PIPELINE'),
        icon: 'i-lucide-kanban',
        to: accountScopedRoute('pipeline_view'),
        activeOn: ['pipeline_view', 'pipeline_funnel_view', 'pipeline_deal'],
      },
      {
        name: 'Agenda',
        label: t('SIDEBAR.AGENDA'),
        icon: 'i-lucide-calendar',
        to: accountScopedRoute('pipeline_calendar'),
        activeOn: ['pipeline_calendar'],
      },
      {
        name: 'Companies',
        label: t('SIDEBAR.COMPANIES'),
        icon: 'i-lucide-building-2',
        to: accountScopedRoute('companies_dashboard_index'),
        activeOn: ['companies_dashboard_index', 'company_show'],
      },
      {
        name: 'Products',
        label: t('SIDEBAR.PRODUCTS'),
        icon: 'i-lucide-package',
        to: accountScopedRoute('products_list'),
        activeOn: ['products_list', 'products_wrapper'],
      },
      {
        name: 'Results',
        label: t('SIDEBAR.PROSPECTING_RESULTS'),
        icon: 'i-lucide-chart-bar',
        children: [
          {
            name: 'ReportsPipeline',
            label: t('SIDEBAR.REPORTS_PIPELINE'),
            icon: 'i-lucide-chart-spline',
            to: accountScopedRoute('kanban_reports'),
            activeOn: ['kanban_reports'],
          },
          {
            name: 'CrmReports',
            label: t('SIDEBAR.CRM_REPORTS'),
            icon: 'i-lucide-pie-chart',
            to: accountScopedRoute('crm_reports'),
            activeOn: ['crm_reports'],
          },
          {
            name: 'SalesGoals',
            label: t('SIDEBAR.SALES_GOALS'),
            icon: 'i-lucide-target',
            to: accountScopedRoute('sales_goals_list'),
            activeOn: ['sales_goals_list'],
          },
          {
            name: 'LossReasons',
            label: t('SIDEBAR.LOSS_REASONS'),
            icon: 'i-lucide-thumbs-down',
            to: accountScopedRoute('loss_reasons_list'),
            activeOn: ['loss_reasons_list'],
          },
        ],
      },
      {
        name: 'Setup',
        label: t('SIDEBAR.PROSPECTING_CONFIG'),
        icon: 'i-lucide-bolt',
        children: [
          {
            name: 'ManageFunnels',
            label: t('SIDEBAR.MANAGE_FUNNELS'),
            icon: 'i-lucide-filter',
            to: accountScopedRoute('manage_funnels'),
            activeOn: ['manage_funnels', 'funnel_settings'],
          },
          {
            name: 'AiIgnoredNumbers',
            label: t('SIDEBAR.AI_IGNORED_NUMBERS'),
            icon: 'i-lucide-bot-off',
            to: accountScopedRoute('ai_ignored_numbers_list'),
            activeOn: ['ai_ignored_numbers_list', 'ai_ignored_numbers_wrapper'],
          },
          {
            name: 'Voices',
            label: t('SIDEBAR.VOICES'),
            icon: 'i-lucide-mic',
            to: accountScopedRoute('voices_list'),
            activeOn: ['voices_wrapper', 'voices_list'],
          },
        ],
      },
    ],
  };
}
